module.exports = __webpack_public_path__ + "img/high_five_ellipse.9461d88d.png";